import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { components } from '@glowforge/ui-common';

import './submit-actions.less';

const { Button } = components;

const SubmitActions = (props) => {
  // TODO: Fix all uses of userSubmitError to use SubmissionError error
  // Do not show error if form is submitting
  const err = !props.submitting && (props.error || props.userSubmitError);
  const actionClasses = classnames('SubmitActions', {
    submitting: props.submitting,
    submitSucceeded: !props.submitting && props.submitSucceeded && !err,
    error: !props.submitting && err,
  });

  const cancelButton = props.onCancel && !props.submitting && !props.submitSucceeded ?
    <Button type='text' onClick={props.onCancel}>cancel</Button> : null;

  return (
    <div className={actionClasses}>
      <div className='saving'>{props.inProgressMessage}</div>
      <div className='saved'>{props.successMessage}</div>
      <div className='errorMessage'>{err}</div>
      {cancelButton}
      <Button
        isSubmit
        className={props.submitClass}
        disabled={props.disabled || props.submitting}>{props.submitText}</Button>
    </div>
  );
};

SubmitActions.propTypes = {
  submitText: PropTypes.string,
  successMessage: PropTypes.string,
  disabled: PropTypes.bool,
  inProgressMessage: PropTypes.string,
  submitClass: PropTypes.string,
  submitting: PropTypes.bool,
  submitSucceeded: PropTypes.bool,
  userSubmitError: PropTypes.string,
  error: PropTypes.string,
  onCancel: PropTypes.func,
};


SubmitActions.defaultProps = {
  error: null,
  userSubmitError: null,
  submitText: 'Save Changes',
  successMessage: 'Saved!',
  disabled: false,
  inProgressMessage: 'Saving...',
  onCancel: null,
  submitClass: null,
  submitSucceeded: false,
  submitting: false,
};

export default SubmitActions;



// WEBPACK FOOTER //
// ./app/common/components/forms/submit-actions.jsx